import React, { useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useAppDispatch } from '../../Hooks';
import { upDateActivity } from '../../redux/Actions';
import { FormEdit, FormErrors } from '../../types';
import { EvenChanges, EvenSubmit } from '../../types/Functions';
import { FormEdited } from './FormEdit';
import { validation } from './Validation';

export const EditActivity = () => {
  const formState: FormEdit = {
    name: "",
    difficulty: 0,
    duration: "",
    season: "",
    // country: [],
  }

  const formErrors: FormErrors = {
    name: "",
    difficulty: "",
    duration: "",
    season: "",
    // country: [],
  }
  
  const [activity, setActivity] = useState<FormEdit>(formState);

  const [errors, setErrors] = useState<FormErrors>(formErrors);
  const dispatch = useAppDispatch();
  const { id } = useParams<{id: string}>();
  const history = useHistory();

  const handlerChange: EvenChanges = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    setActivity({
      ...activity,
      [e.target.name]: e.target.value,
    });
    setErrors(
      validation({
        ...activity,
        [e.target.name]: e.target.value,
      })
    );
  };

  const handlerSubmit: EvenSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (
      activity.name &&
      activity.difficulty &&
      activity.duration &&
      activity.season
    ) {
      dispatch<any>(upDateActivity(activity, id));
      alert("Has actualizado la Actividad!🤩");
      //* Seteo TODO desde CERO
      setActivity(formState);
      history.push("/activities");
    } else {
      alert("No puedes dejar ningun campo vasío!!");
    }
  };

  return (
    <FormEdited
      activity={activity}
      errors={errors}
      handlerChange={handlerChange}
      handlerSubmit={handlerSubmit}
    />
  )
}
